import { TonConnectUIProvider } from '@tonconnect/ui-react'
import 'css-paint-polyfill'
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import 'swiper/css'

import App from './App'
import config from './config'
import i18n from './i18n'
import { getLanguage } from './store/gameSettings'

const RootComponent = () => {

  useEffect(() => {
    const language = getLanguage()
    if (language && language !== i18n.language) {
      i18n.changeLanguage(language)
    }
  }, [])

  return (
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <TonConnectUIProvider manifestUrl={config.tonConnectManifestUrl}>
          <App />
        </TonConnectUIProvider>
      </I18nextProvider>
    </React.StrictMode>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<RootComponent />)
